// Maps current pathname → moduleKey used by /app/frontend/src/config/moduleGuides.js
// Used by the global floating "How to use this module" button in DashboardLayout.
const RULES = [
  // Most specific first
  [/^\/material-tracking/,                        'mtm'],
  [/^\/piping-workfront/,                         'pwm'],
  [/^\/structural-workfront/,                     'swm'],
  [/^\/project-controls\/procurement/,            'procurement'],
  [/^\/project-controls\/construction/,           'construction'],
  [/^\/project-controls\/engineering/,            'engineering'],
  [/^\/project-controls\/commissioning/,          'commissioning'],
  [/^\/project-controls\/raid/,                   'raid'],
  [/^\/project-controls\/hse/,                    'hse'],
  [/^\/project-controls\/site-monitoring/,        'site'],
  [/^\/project-controls\/progress-reports/,       'progress'],
  [/^\/project-controls\/scan-to-model/,          'scanToModel'],
  [/^\/project-controls\/cost\/budget-revisions/, 'budget'],
  [/^\/project-controls\/cost\/commitments/,      'commitments'],
  [/^\/project-controls\/cost\/invoices/,         'invoices'],
  [/^\/project-controls\/cost\/working-capital/,  'wcm'],
  [/^\/project-controls\/cost\/evm/,              'evm'],
  [/^\/project-controls\/cost\/cbs/,              'cost'],
  [/^\/project-controls\/cost\/manpower/,         'manpower'],
  [/^\/project-controls\/cost\/equipment/,        'equipment'],
  [/^\/project-controls\/cost\/5d-model/,         'fiveD'],
  [/^\/project-controls\/cost/,                   'cost'],
  [/^\/project-controls\/4d-model/,               'fourD'],
  [/^\/project-controls\/schedule-rollup/,        'scheduling'],
  [/^\/project-controls\/macro/,                  'scheduling'],
  [/^\/project-controls(\/?|$)/,                  'controls'],
  [/^\/contracts/,                                'contracts'],
  [/^\/tenders/,                                  'tender'],
  [/^\/portfolio-map/,                            'portfolio'],
  [/^\/benchmarking/,                             'benchmarking'],
  [/^\/trends/,                                   'trends'],
  [/^\/ai-brief/,                                 'aiBrief'],
  [/^\/alerts/,                                   'alerts'],
];

export function getModuleKeyFromPath(pathname) {
  for (const [re, key] of RULES) {
    if (re.test(pathname)) return key;
  }
  return null;
}
